// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2osr1","unreadBadge":"styles_unreadBadge__340lF","modalContent":"styles_modalContent__2en3C","modal":"styles_modal__QmRoT"};